import type { NextRouter } from 'next/router';
import type { IErrorState } from '../ErrorBoundary';
import { ErrorDialog } from '../ErrorDialog';

export default function DefaultErrorFallback(props: IErrorState & { router: NextRouter }) {
	const returnLink = props.router.asPath.includes('/field') ? '/field' : '/';

	return (
		<ErrorDialog dialogOpen={true}>
			<h2 className="text-4xl font-medium py-3 px-4 bg-glazier-blue-800 rounded-t-md text-white">Error</h2>
			<div>
				<p className="py-3 px-4 font-medium text-3xl text-center">Whoops! An error occurred.</p>
				{/* If there is a stacktrace, display it in a scrollable box */}
				{props.stackTrace ? (
					<div className="max-h-[300px] overflow-y-auto px-2">
						<p className="">Error: {props.stackTrace}</p>
					</div>
				) : (
					''
				)}
			</div>
			<div className="w-full flex justify-center px-2 pt-2 pb-4 space-x-6">
				{/* NOTE: Commenting this out: would be nice to have a back button that can reload the previous route without an error,
        // theoretically if we put the ErrorBoundary above the children within a Layout component that should work. 
        <button type="button" className="black-button-xl" onClick={() => this.props.router.back()}>
                    Back
                </button> */}
				<button type="button" className="black-button-xl" onClick={() => props.router.push(returnLink)}>
					Home
				</button>
			</div>
		</ErrorDialog>
	);
}
